import { set } from 'microcosm'
import {
  filterRegion,
  focusChartShape,
  blurChartShape,
  toggleFixed
} from '../actions/ui'

const UIStore = {
  getInitialState() {
    return {
      fixed: false,
      focused: null,
      region: {
        value: 'US',
        text: 'US Market'
      }
    }
  },

  setRegion(state, region) {
    return set(state, 'region', region)
  },

  setFocused(state, id) {
    return set(state, 'focused', id)
  },

  unsetFocused(state) {
    return set(state, 'focused', null)
  },

  toggleFixed(state, shouldFix) {
    return set(state, 'fixed', shouldFix)
  },

  register() {
    return {
      [filterRegion]: this.setRegion,
      [focusChartShape]: this.setFocused,
      [blurChartShape]: this.unsetFocused,
      [toggleFixed]: this.toggleFixed
    }
  }
}

export default UIStore



// WEBPACK FOOTER //
// ./src/domains/ui.js